/* Explosion de poudre de cacao (canvas, derrière le sachet) : une seule bouffée de poudre fine, au ralenti,
   qui jaillit de derrière le sachet, s'ouvre en couronne autour de lui puis retombe en voile, et recommence.
   Usage : <div data-powder-burst> <img> <canvas></canvas> </div>, le canvas placé sous l'image.
   Point d'éclatement : data-powder-x / data-powder-y, en fraction de l'image (défaut : derrière le milieu du sachet).
   Sans animation (réduire les animations) : une image fixe en pleine explosion. Copié dans theme/assets/powder-burst.js.
   Options : data-powder-spread="ring" (explose tout autour du sachet, en jets de poudre fine avec traînées de vitesse),
   data-powder-period (secondes entre deux bouffées),
   data-powder-origin="stage" (point d'éclatement en fraction du bloc et non de l'image).
   À chaque bouffée, le bloc reçoit la classe is-burst (≈ 0,9 s) pour animer le sachet en CSS. */
(function () {
  const tones = ['#3b2418', '#4e3022', '#62402d', '#76503a', '#8a6248', '#a07a5e'];
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const PERIOD = 6.2;

  function mount(stage) {
    if (stage.dataset.powderReady) return;
    stage.dataset.powderReady = '1';
    const canvas = stage.querySelector('canvas');
    const ctx = canvas && canvas.getContext('2d');
    if (!ctx) return;
    const img = stage.querySelector('img');
    const ring = stage.dataset.powderSpread === 'ring';
    const period = parseFloat(stage.dataset.powderPeriod) || PERIOD;

    let w = 0, h = 0, k = 1, dpr = 1, ox = 0, oy = 0;
    const grains = [];
    const clouds = [];
    let visible = false;
    let last = 0;
    let clock = 0;
    let next = 0.35;
    /* graine fixe : la même explosion d'un chargement à l'autre */
    let seed = 11;
    const rnd = () => (seed = (seed * 16807) % 2147483647) / 2147483647;

    function resize() {
      dpr = Math.min(2, window.devicePixelRatio || 1);
      w = stage.clientWidth;
      h = stage.clientHeight;
      k = w / 400;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const fx = parseFloat(stage.dataset.powderX || '0.52');
      const fy = parseFloat(stage.dataset.powderY || '0.4');
      if (img && img.offsetWidth && stage.dataset.powderOrigin !== 'stage') {
        /* l'image peut ne pas être chargée : sa hauteur se déduit de ses proportions (carrée par défaut) */
        const ratio = img.naturalWidth ? img.naturalHeight / img.naturalWidth : 1;
        ox = img.offsetLeft + fx * img.offsetWidth;
        oy = img.offsetTop + fy * img.offsetWidth * ratio;
      } else {
        ox = w * fx;
        oy = h * fy;
      }
      /* changer la taille du canvas l'efface : on redessine tout de suite (utile pour l'image fixe) */
      draw();
    }

    function burst() {
      /* nuage : grosses bouffées de cacao qui gonflent en couronne autour du sachet, puis se dissipent */
      const browns = ['92,58,40', '112,74,52', '134,96,70', '158,120,92'];
      /* en couronne : la poudre part en une douzaine de jets, comme une vraie explosion */
      const jets = [];
      for (let i = 0; ring && i < 12; i++) jets.push((i / 12) * Math.PI * 2 + rnd() * 0.45);
      const aim = (spread) => (rnd() < 0.7 ? jets[(rnd() * jets.length) | 0] + (rnd() - 0.5) * spread : rnd() * Math.PI * 2);
      stage.classList.remove('is-burst');
      void stage.offsetWidth;
      stage.classList.add('is-burst');
      clearTimeout(stage._powderKick);
      stage._powderKick = setTimeout(() => stage.classList.remove('is-burst'), 900);
      for (let i = 0; i < (ring ? 96 : 74); i++) {
        const a = ring ? aim(0.5) : -Math.PI / 2 + (rnd() * 2 - 1) * 1.85;
        const v = (110 + rnd() * 360) * k;
        clouds.push({
          x: ox + (rnd() - 0.5) * 70 * k,
          y: oy + (rnd() - 0.5) * 30 * k,
          vx: Math.cos(a) * v,
          vy: Math.sin(a) * v,
          r: (ring ? 9 + rnd() * 10 : 14 + rnd() * 12) * k,
          grow: (ring ? 18 + rnd() * 26 : 26 + rnd() * 34) * k,
          t: 0,
          life: 3 + rnd() * 1.6,
          peak: ring ? 0.2 + rnd() * 0.12 : 0.3 + rnd() * 0.16,
          c: browns[(rnd() * browns.length) | 0]
        });
      }
      /* poudre fine : grains projetés juste au-delà du nuage, freinés très vite par l'air */
      for (let i = 0; i < (ring ? 2600 : 1500); i++) {
        const a = ring ? aim(0.24) : -Math.PI / 2 + (rnd() * 2 - 1) * 1.9 * Math.sqrt(rnd());
        const fine = rnd() < 0.85;
        const v = (ring ? 380 + rnd() * 860 : 320 + rnd() * 620) * k;
        grains.push({
          x: ox + (rnd() - 0.5) * 60 * k,
          y: oy + (rnd() - 0.5) * 24 * k,
          vx: Math.cos(a) * v,
          vy: Math.sin(a) * v,
          r: (fine ? 0.3 + rnd() * 0.45 : 0.75 + rnd() * 0.7) * k,
          c: (rnd() * tones.length) | 0,
          t: 0,
          life: 2 + rnd() * 2,
          drag: fine ? 3.2 + rnd() * 1.4 : 2.2,
          fall: (fine ? 22 : 120) * k,
          ph: rnd() * 6.28
        });
      }
    }

    function frame(dt) {
      clock += dt;
      if (clock >= next) {
        burst();
        next = clock + period;
      }
      for (let i = grains.length - 1; i >= 0; i--) {
        const g = grains[i];
        g.t += dt;
        if (g.t >= g.life) { grains[i] = grains[grains.length - 1]; grains.pop(); continue; }
        const f = 1 - Math.min(1, g.drag * dt);
        /* léger tourbillon : la poudre flotte au lieu de tomber droit */
        g.vx = g.vx * f + Math.sin(g.t * 2.2 + g.ph) * 18 * k * dt;
        g.vy = g.vy * f + g.fall * dt;
        g.x += g.vx * dt;
        g.y += g.vy * dt;
      }
      for (let i = clouds.length - 1; i >= 0; i--) {
        const c = clouds[i];
        c.t += dt;
        if (c.t >= c.life) { clouds[i] = clouds[clouds.length - 1]; clouds.pop(); continue; }
        const f = 1 - Math.min(1, 1.6 * dt);
        c.vx *= f;
        c.vy = c.vy * f + 4 * k * dt;
        c.x += c.vx * dt;
        c.y += c.vy * dt;
        c.r += c.grow * dt;
      }
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);
      for (const c of clouds) {
        const u = c.t / c.life;
        /* dense à l'éclatement, puis se dissipe */
        const a = c.peak * Math.min(1, u * 8) * Math.pow(1 - u, 1.3);
        const grad = ctx.createRadialGradient(c.x, c.y, 0, c.x, c.y, c.r);
        grad.addColorStop(0, 'rgba(' + c.c + ',' + a.toFixed(3) + ')');
        grad.addColorStop(1, 'rgba(' + c.c + ',0)');
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(c.x, c.y, c.r, 0, Math.PI * 2);
        ctx.fill();
      }
      /* couronne : les grains encore rapides laissent une courte traînée, comme sur une photo à grande vitesse */
      if (ring) {
        ctx.lineCap = 'round';
        ctx.globalAlpha = 0.3;
        for (let t = 0; t < tones.length; t++) {
          ctx.strokeStyle = tones[t];
          ctx.lineWidth = 0.7 * k;
          ctx.beginPath();
          for (const g of grains) {
            if (g.c !== t) continue;
            const sp = Math.abs(g.vx) + Math.abs(g.vy);
            if (sp < 420 * k) continue;
            ctx.moveTo(g.x - g.vx * 0.009, g.y - g.vy * 0.009);
            ctx.lineTo(g.x, g.y);
          }
          ctx.stroke();
        }
        ctx.globalAlpha = 1;
      }
      /* grains : un tracé par teinte et par palier d'opacité ; les plus fins en petits carrés (plus rapide) */
      for (let level = 1; level <= 4; level++) {
        ctx.globalAlpha = level / 4;
        for (let t = 0; t < tones.length; t++) {
          ctx.fillStyle = tones[t];
          ctx.beginPath();
          for (const g of grains) {
            if (g.c !== t) continue;
            const fade = Math.min(1, g.t / 0.06, (g.life - g.t) / (g.life * 0.45));
            if (Math.max(1, Math.ceil(fade * 4)) !== level) continue;
            if (g.r < 0.8 * k) ctx.rect(g.x - g.r, g.y - g.r, g.r * 2, g.r * 2);
            else { ctx.moveTo(g.x + g.r, g.y); ctx.arc(g.x, g.y, g.r, 0, Math.PI * 2); }
          }
          ctx.fill();
        }
      }
      ctx.globalAlpha = 1;
    }

    function loop(now) {
      if (!canvas.isConnected) return;
      const dt = Math.min(0.05, (now - last) / 1000 || 0);
      last = now;
      if (visible) {
        frame(dt);
        draw();
      }
      requestAnimationFrame(loop);
    }

    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(stage);
    else window.addEventListener('resize', resize);
    if (img && !img.complete) img.addEventListener('load', resize, { once: true });

    if (reduce) {
      /* image fixe : l'explosion à son plus bel instant */
      for (let t = 0; t < 1.3; t += 1 / 60) frame(1 / 60);
      draw();
      return;
    }
    /* contrôle visuel : ?powder-t=1.2 fige l'animation à cet instant */
    const still = parseFloat(new URLSearchParams(location.search).get('powder-t'));
    if (still >= 0) {
      for (let t = 0; t < still; t += 1 / 60) frame(1 / 60);
      draw();
      return;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => (visible = en.isIntersecting), { rootMargin: '100px' }).observe(stage);
    } else {
      visible = true;
    }
    requestAnimationFrame((t) => { last = t; loop(t); });
  }

  function init() {
    document.querySelectorAll('[data-powder-burst]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* éditeur de thème Shopify : la section peut être rechargée */
  document.addEventListener('shopify:section:load', init);
})();
